import {OrderManager, PersonalOfferService, PickupUtil} from '@nuskin/ns-shop';
import {ShippingAddressAdapter} from '@nuskin/ns-shop';
import SectionEnum from './sectionEnum';
import CartUtil from './cartUtil';
import DropShipUtil from './dropShipUtil';
import {getCachedConfigField, getCachedConfiguration} from '@nuskin/configuration-sdk';
import _ from 'lodash';

const ShippingAddressUtil = function() {
    'use strict';

    let $scope;
    let nsUtil;
    let nsShipping;
    let nsPersonalOfferStep;    // eslint-disable-line
    let vueResolve;
    let shipMethodsResolve;
    let simulatePromises;

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    const publicMethods = {
        // If user is authenticated get shipping addresses from profile and set the default selected shipping address.
        initShippingAddresses: function(scope, nsUtilService, nsShippingService, simulatePromiseDependencies) {
            $scope = scope;
            nsUtil = nsUtilService;
            nsShipping = nsShippingService;
            nsPersonalOfferStep = PersonalOfferService; // eslint-disable-line
            simulatePromises = simulatePromiseDependencies;

            $scope.isShippingChanging = false;
            $scope.shippingMethodChangeCount = 0;

            $scope.shippingPromise = new Promise((resolve, reject) => {
                vueResolve = resolve;
            });
            simulatePromises.push($scope.shippingPromise);

            // Still used even when we are using the new shipping address component
            $scope.addSAPShippingAddress = addSAPShippingAddress;

            $scope.$watchCollection('order.selectedShippingMethod', function(newValue, oldValue) {
                // if old value is null then that means we just barely did the original simulate.
                // No need to do it again.
                if (!nsUtil.isEmpty(newValue)) {
                    $scope.sections.shipmethod.showPickUpPerson = newValue.Code === 'M3';
                }
                if (!nsUtil.isEmpty(oldValue) &&
                  !nsUtil.isEmpty(newValue) &&
                  newValue.Code != $scope.order.simulatedShippingMethod.Code &&
                  (newValue.Code != oldValue.Code || newValue.PickUpLocation != oldValue.PickUpLocation)) {
                    $scope.shippingMethodChangeCount++;
                    $scope.simulateOrderWithElement($scope.order.selectedShippingMethod);
                }
                DropShipUtil.checkDropShip();
            });
        },
        mapStateToDisplay: function(address) {
            if (address && Object.prototype.hasOwnProperty.call(address, 'getShippingState')) {
                const stateMapping = getCachedConfigField('stateMapping');
                if (stateMapping) {
                    let stateMappingArray = [];
                    if (typeof stateMapping !== 'object') {
                        stateMappingArray.push(stateMapping);
                    } else {
                        stateMappingArray = stateMapping;
                    }
                    stateMappingArray.forEach((mapping) => {
                        const stateMapping = mapping.split('=');
                        if (stateMapping.length === 2) {
                            const sapState = stateMapping[0];
                            const displayState = stateMapping[1];
                            if (address.getShippingState() === sapState) {
                                address.setShippingState(displayState);
                            }
                        }
                    });
                }
            }
        },
        mapStateToSAP: function(address) {
            if (address && Object.prototype.hasOwnProperty.call(address, 'getShippingState')) {
                const stateMapping = getCachedConfigField('stateMapping');
                if (stateMapping) {
                    let stateMappingArray = [];
                    if (typeof stateMapping !== 'object') {
                        stateMappingArray.push(stateMapping);
                    } else {
                        stateMappingArray = stateMapping;
                    }
                    stateMappingArray.forEach((mapping) => {
                        const stateMapping = mapping.split('=');
                        if (stateMapping.length === 2) {
                            const sapState = stateMapping[0];
                            const displayState = stateMapping[1];
                            if (address.getShippingState() === displayState) {
                                address.setShippingState(sapState);
                            }
                        }
                    });
                }
            }
        },
        setShippingComponentAddress: function(address) {
            const shippingElement = document.getElementById('newShippingSection');
            shippingElement.address = address.toJSON();
        },
        injectShippingComponent: function() {
            // eslint-disable-next-line no-undef
            const appCfg = __APP_CONFIG__;

            const baseSelector = `<ns-address-selector
                id="newShippingSection"
                context="CHECKOUT"
                ${$scope.order.distributorName ?
        `dist-name="${$scope.order.distributorName}"` :
        ''}
                cs-api-key="${appCfg.contentstack.apiKey}"
                cs-delivery-token="${appCfg.contentstack.deliveryToken}"
                cs-environment="${appCfg.contentstack.environment}"
                ${($scope.order.selectedAddress && $scope.order.selectedAddress.beShippingAddressId) ?
        `initial-address-id="${$scope.order.selectedAddress.beShippingAddressId}"` :
        ''}
            />`;
            const nsAddressSelector = $scope.order.simulateWithoutShipping ?
                baseSelector.replace('/>', 'readonly/>') :
                baseSelector;
            // eslint-disable-next-line
            document.getElementById('checkout-shipping-selector').innerHTML = nsAddressSelector;
            const shippingElement = document.getElementById('newShippingSection');

            const adrAddress = getAdrOverrideAddress();
            if (adrAddress) {
                shippingElement.addedAddress = adrAddress.toJSON();
            }

            initShippingComponentListeners(shippingElement);
        }
    };

    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------
    /**
     * Adds event listeners to payment component to integrate with the angular checkout application
     * @param paymentElement dom element for the new payment component
     */
    function initShippingComponentListeners(shippingElement) {
        if (shippingElement && typeof shippingElement.addEventListener === 'function') {
            let needToFinishInitializing = false;

            shippingElement.addEventListener('input', (event) => {
                // Set the payment on the order object
                if (event.detail && event.detail.length > 0) {
                    const {metapackMarket, useShipMethodsApi} = getCachedConfiguration('Checkout');
                    if (metapackMarket && useShipMethodsApi && !shipMethodsResolve) {
                        simulatePromises.push(new Promise((resolve) => {
                            shipMethodsResolve = resolve;
                        }));
                    }

                    needToFinishInitializing = !vueResolve && !$scope.order.selectedAddress && !!event.detail[0];

                    $scope.order.selectedAddress = event.detail[0];
                    if ($scope.order.selectedAddress) {
                        if (!$scope.currentSelectedAddress) {
                            $scope.currentSelectedAddress = $scope.order.selectedAddress;
                        }
                        $scope.shippingAddresses = [$scope.order.selectedAddress];

                        // Let payment section know of newly selected shippingAddress
                        const paymentElement = document.getElementById('newPaymentSection');
                        if (paymentElement) {
                            paymentElement.setAttribute('billing-address', JSON.stringify($scope.shippingAddresses[0]));
                        }
                    }
                    if (typeof vueResolve === 'function') {
                        vueResolve();
                        vueResolve = null;
                    }
                }
            });
            shippingElement.addEventListener('state', (event) => {
                if (event.detail && event.detail.length > 0) {
                    const {state, readOnly} = event.detail[0];

                    if (state === 'busy' || state === 'not-busy') {
                        $scope.shippingBusy = state === 'busy';
                    } else {
                        $scope.shippingState = state;
                        if ($scope.shippingState === 'complete') {
                            const {metapackMarket, useShipMethodsApi} = getCachedConfiguration('Checkout');
                            if (metapackMarket && useShipMethodsApi) {
                                PickupUtil.loadShipMethods();
                                // The simulate is waiting for loadShipMethods. The
                                // following clears the promise to allow this to happen.
                                PickupUtil.getShipMethods().then(() => {
                                    if (typeof shipMethodsResolve === 'function') shipMethodsResolve();
                                    shipMethodsResolve = null;
                                });
                            }

                            $scope.sections.shipping.edit = false;
                            if (needToFinishInitializing) {
                                $scope.currentSelectedAddress = $scope.order.selectedAddress;
                                CartUtil.initializeCart();
                                if ($scope.sections.initialized) {
                                    $scope.continueEdit(SectionEnum.SHIPPING);
                                }
                                needToFinishInitializing = false;
                            } else if ($scope.sections.initialized && !_.isEqual($scope.currentSelectedAddress, $scope.order.selectedAddress)) {
                                $scope.currentSelectedAddress = $scope.order.selectedAddress;
                                if (!readOnly) {
                                    $scope.simulateOrder().then(() => {
                                        // If the pickup ship method is selected then when we simulate we will get a new list of pickup locations
                                        if ($scope.order.pickupPoints) {
                                            // Make the user select a pickup location again
                                            $scope.sections.shipmethod.pristine = true;
                                        }
                                        $scope.continueEdit(SectionEnum.SHIPPING);
                                    });
                                }
                            }
                            DropShipUtil.checkDropShip();
                        } else if ($scope.shippingState === 'edit') {
                            $scope.sections.shipping.edit = true;
                        }
                    }
                    if ($scope.$$phase != '$apply' && $scope.$$phase != '$digest') {
                        $scope.$apply();
                    }
                }
            });
            shippingElement.addEventListener('distributor-name', (event) => {
                if (event.detail && event.detail.length > 0) {
                    $scope.order.distributorName = event.detail[0];
                    OrderManager.saveOrders();
                }
            });
            shippingElement.addEventListener('signature-required', (event) => {
                if (event.detail && event.detail.length > 0) {
                    $scope.order.signatureRequired = event.detail[0];
                }
            });
        }
    }

    function getAdrOverrideAddress() {
        let adrAddress = null;

        // If order is ADR Override, default to the ADR's on-file shipping address
        if ($scope.overriddenADR) {
            const shippingParties = $scope.overriddenADR.SalesOrderDetail.Shipping.ShippingParty;
            const shippingMethod = $scope.overriddenADR.SalesOrderDetail.Shipping.ShippingMethod;
            const shipToParty = shippingParties.find((s) => s.Type === 'SHIP_TO');
            const pickUp = shippingMethod && (shippingMethod.Code =='PU' || shippingMethod.Code == 'FP');
            if (shipToParty && !pickUp) {
                adrAddress = ShippingAddressAdapter.mapShippingPartyToShippingAddress(shipToParty);
            }
        }

        return adrAddress;
    }

    function addSAPShippingAddress(address) {
        if (typeof address !== 'undefined' && $scope.user) {
            // TODO: remove eid from param object when we move to AWS shipping profile service
            nsShipping.save({sapId: $scope.user.id, eid: $scope.user.eid}, address,
                function() {
                    // success
                    console.log('Added SAP default address to profile');
                },
                function(httpResponse) {
                    // error
                    console.error('Could not save SAP default address to profile: ', httpResponse);
                });
        }
    }

    return publicMethods;
}();

export default ShippingAddressUtil;
